import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

import { useDispatch, useSelector } from 'react-redux';
import { createPersonRequest } from '../../store/modules/person/actions';

import jsPdfGenerator from '../../services/generatePDF';

import Input from '../../components/Input';
import Button from '../../components/Button';
import Small from '../../components/Small';

import Layout from '../../pages/_layouts/default';
import * as S from './styled';

import icon from "../../assets/user.png"

const Register = () => {

  const dispatch = useDispatch();
  const loading = useSelector(state => state.auth.loading);

  const user = useSelector(state => state.user.profile.name);

  const [name, setName] = useState("");
  const [cpf, setCpf] = useState("");
  const [validCpf, setValidCpf] = useState("");
  const [birthday, setBirthday] = useState("");
  const [family_count, setFamily_count] = useState("");
  const [ocupation, setOcupation] = useState("");
  const [status, setStatus] = useState("");
  const [nis, setNis] = useState("");
  const [contact, setContact] = useState("");
  const [address, setAddress] = useState("");
  const [neighborhood, setNeighborhood] = useState("");

  const [borderName, setBorderName] = useState("#FDCB00");
  const [borderCpf, setBorderCpf] = useState("#FDCB00");
  const [borderBirthday, setBorderBirthday] = useState("#FDCB00");
  const [borderFamily_count, setBorderFamily_count] = useState("#FDCB00");
  const [borderOcupation, setBorderOcupation] = useState("#FDCB00");
  const [borderStatus, setBorderStatus] = useState("#FDCB00");
  const [borderNis, setBorderNis] = useState("#FDCB00");
  const [borderContact, setBorderContact] = useState("#FDCB00");
  const [borderAddress, setBorderAddress] = useState("#FDCB00");
  const [borderNeighborhood, setBorderNeighborhood] = useState("#FDCB00");


  function validationInput(e, inputType) {

    if (inputType === 'name') {

      const inputLength = e.length;

      if (inputLength <= 5) {
        setBorderName('#CE1717');
      } else {
        setBorderName('#1FA528');
      }
    }

    if (inputType === 'cpf') {

      const inputLength = e.replace(/_/g, '').length;

      if (inputLength < 14) {
        setBorderCpf('#CE1717');
      } else {
        setBorderCpf('#1FA528');
      }
    }

    if(inputType === 'birthday') {
      
      const inputLength = e.replace(/_/g, '').length;
      
      if (inputLength > 0) {
        setBorderBirthday('#1FA528');
      } else {
        setBorderBirthday('#CE1717');
      }
    }

    if(inputType === 'ocupation') {

     if (e.length > 0) {
      setBorderOcupation('#1FA528');
     } else {
      setBorderOcupation('#CE1717');
     }
    }

    if(inputType === 'status') {

     if (e.length > 0) {
      setBorderStatus('#1FA528');
     } else {
      setBorderStatus('#CE1717');
     }
    }

    if(inputType === 'nis') {

      if (e.length > 0) {
        setBorderNis('#1FA528');
      } else {
        setBorderNis('#CE1717');
      }
    }
    
    if(inputType === 'address') {

      if (e.length >= 6) {
        setBorderAddress('#1FA528');
      } else {
        setBorderAddress('#CE1717');
      }
    }
    
    if(inputType === 'neighborhood') {

      if (e.length > 0) {
        setBorderNeighborhood('#1FA528');
      } else {
        setBorderNeighborhood('#CE1717');
      }
    }

    if(inputType === 'contact') {
      
      const inputLength = e.replace(/_/g, '').length;
      
      if (inputLength > 0) {
        setBorderContact('#1FA528');
      } else {
        setBorderContact('#CE1717');
      }
    }
    
  }
  
  async function handleSubmit(e) {
    e.preventDefault();

    if(!name || !cpf || !address || !user) {
         toast.error('Campo(s) Vazio(s)');
         return;
       }
    
    // await jsPdfGenerator(
    //   name, cpf, nis, family_count, ocupation, address, 
    //   birthday, contact, neighborhood, status, user
    // );
    

    dispatch(createPersonRequest(
      name, birthday, status, ocupation, family_count, 
      cpf, nis, contact, address, neighborhood)
    );
   
    setName("");
    setCpf("");
    setBirthday("");
    setFamily_count("");
    setOcupation("");
    setStatus("");
    setNis("");
    setContact("");
    setAddress("");
    setNeighborhood("");
    
    setBorderName("#FDCB00");
    setBorderCpf("#FDCB00");
    setBorderBirthday("#FDCB00");
    setBorderFamily_count("#FDCB00");
    setBorderOcupation("#FDCB00");
    setBorderStatus("#FDCB00");
    setBorderNis("#FDCB00");
    setBorderContact("#FDCB00");
    setBorderAddress("#FDCB00");
    setBorderNeighborhood("#FDCB00");
  }

  useEffect(() => {
    setCpf(validCpf);
  }, [validCpf]);

  return (
    <Layout>
      <S.Container>
        {/* <div className="header">
          <img src={icon} alt="Peixe Solidário" />
          <h1>Cadastrar Pessoa</h1>
        </div> */}

        <S.Form onSubmit={ handleSubmit }>
          <div>
            <Input 
              type="text" 
              placeholder="Nome completo" 
              label="Nome"
              value={ name }
              method={ e => {
                setName(e.target.value);
                validationInput(e.target.value, 'name')
              }}
              border={ borderName } 
              width="60%"
            />
            <Input 
              type="text" 
              placeholder="000.000.000-00"
              mask="999.999.999-99" 
              label="CPF"
              value={ cpf }
              method={ e => {
                setValidCpf(e.target.value);
                validationInput(e.target.value, 'cpf'); 
              }}
              border={ borderCpf }
              width="40%"
            />
          </div>
          <div>
            <Input 
              type="text" 
              placeholder="21/02/1990"
              mask="99/99/9999" 
              label="Data de nascimento" 
              value={ birthday }
              method={ e => {
                setBirthday(e.target.value);
                validationInput(e.target.value, 'birthday')
              }}
              border={ borderBirthday }
              width="40%"
            />
            <Input 
              type="text" 
              placeholder="00"
              max="2"
              pattern="/^[0-9\b]+$/"
              label="Familiares" 
              value={ family_count }
              method={ e => {
                const regex = /^[0-9\b]+$/;
                const value = e.target.value;
                if (value === '' || regex.test(value)) { 
                  setFamily_count(e.target.value);
                  setBorderFamily_count('#1FA528');
                } else {
                  setBorderFamily_count('#CE1717');
                }
                validationInput(e.target.value, 'family_count')
              }}
              border={ borderFamily_count }
              width="20%"
            />
            <Input 
              type="text" 
              placeholder="Profissão" 
              label="Ocupação" 
              value={ ocupation }
              method={ e => {
                setOcupation(e.target.value);
                validationInput(e.target.value, 'ocupation')
              }}
              border={ borderOcupation }
              width="50%"
            />
          </div>
          <div>
            <Input 
              type="text" 
              placeholder="Solteiro, casado..." 
              label="Estado Civil" 
              value={ status }
              method={ e => {
                setStatus(e.target.value);
                validationInput(e.target.value, 'status')
              }}
              border={ borderStatus }
            />
            <Input 
              type="text" 
              placeholder="Nº do Nis" 
              label="NIS" 
              value={ nis }
              method={ e => {
                const regex = /^[0-9\b]+$/;
                const value = e.target.value;
                if(value === ''||regex.test(e.target.value)) {
                  setNis(e.target.value);
                  validationInput(e.target.value, 'nis')
                }
              }}
              border={ borderNis }
            />
            <Input 
              type="text" 
              placeholder="(81) 90000-0000"
              mask="(99) 99999-9999" 
              label="Telefone" 
              value={ contact }
              method={ e => {
                setContact(e.target.value);
                validationInput(e.target.value, 'contact')
              }}
              border={ borderContact }
            />
          </div>
          <div>
            <Input 
              type="text" 
              placeholder="Rua, Avenida, Sítio e Nº" 
              label="Endereço" 
              value={ address }
              method={ e => {
                setAddress(e.target.value);
                validationInput(e.target.value, 'address')
              }}
              border={ borderAddress }
              width="60%"
            />
            <Input 
              type="text" 
              placeholder="Bairro" 
              label="Bairro" 
              value={ neighborhood }
              method={ e => {
                setNeighborhood(e.target.value);
                validationInput(e.target.value, 'neighborhood')
              }}
              border={ borderNeighborhood }
              width="40%"
            />
          </div>
          <S.ControlsWrapper>
            <Small to="/dashboard">Voltar</Small>
            <Button type="submit" text={ loading ? 'Carregando...' : 'Cadastrar' } background="#0B4683" />
          </S.ControlsWrapper>
        </S.Form>
      </S.Container>
    </Layout>
  );
}

export default Register;